<template lang="pug">
    div.wines
        navbar
        section.section.section-1.is-relative.is-fullview.is-parallax
            div.is-vmiddle
                div.container.has-text-white.has-text-centered
                    h1.is-size-32.is-uppercase.has-text-weight-light(v-html="$t('page_04.section_1.title')")

        section.section.main(id="wines")
            div.container.has-text-centered(v-if="brand")
                h1.is-size-32.is-uppercase {{ brand.nome }}
                div(v-if="history")
                    h2.is-size-7.is-uppercase.has-text-weight-bold.has-letter-spacing-200 {{ $t('page_04.block_02.subtitle') }}
                    div.columns.is-centered
                        div.column.is-8
                            p {{ $i18n.locale === 'pt' ? brand.texto_pt : brand.texto_en }}
                div.columns.is-centered
                    div.column.is-narrow
                        button.button-2.is-size-7.has-letter-spacing-200.is-pointer(@click="history = !history")
                            span.has-border-bottom {{ history ? $t('page_04.button_1.text_2') : $t('page_04.button_1.text_1') }}
                    div.column.is-narrow(v-if="wines.length > 4")
                        button.button-2.is-size-7.has-letter-spacing-200.is-pointer(@click="grid = !grid")
                            span.has-border-bottom {{ grid ? $t('page_04.button_2.text_1') : $t('page_04.button_2.text_2') }}
            wine-list(:wines="wines", :grid="grid")

            div.has-background-white-ter.has-padding-bottom
                div.has-text-centered.grid-close-button(v-if="wines.length > 4 && grid")
                    p.is-size-7.has-letter-spacing-200 .......
                    button.button-2.is-size-7.has-letter-spacing-200.is-pointer(@click="grid = !grid; moveTop(50)")
                        span.has-border-bottom {{ $t('page_04.button_2.text_1') }}

        wine-features(:w="wine", @close="wine = null", @change-wine="changeWine", v-if="wine")
        router-view
        the-footer
</template>

<script>
import Navbar from '@/components/the-navbar'
import TheFooter from '@/components/the-footer'

import WineList from '@/components/wine-list'
import WineFeatures from '@/components/wine-features'

export default {
    name: 'wines',
    components: { Navbar, TheFooter, WineList, WineFeatures },
    data () {
        return {
            brand: null,
            history: false,
            grid: false,
            wines: [],
            wine: null,
            brands: null
        }
    },
    created () {
        this.init()
        this.$bus.$on('open-wine', this.openWine)
    },
    mounted () {
        this.moveTop(500)
    },
    watch: {
        $route () {
            this.grid = false
            this.setBrand()
            this.setWines()
            this.$nextTick(this.moveTop(50))
        }
    },
    methods: {
        async init () {
            try {
                this.brands = await this.$api.getBrands()
                this.submenu = this.brands.map(i => {
                    return {
                        id: i.id,
                        url: i.id,
                        logo: i.imagem
                    }
                })
                this.setBrand()
                this.setWines()
            } catch (err) {
                console.log(err)
            }
        },

        async setWines () {
            try {
                const params = { brand_id: this.$route.params.id }
                const wines = await this.$api.getWines(params)
                this.wines = wines.filter(w => +w.sort !== 0).sort((a, b) => (+a.sort > +b.sort) ? 1 : -1)
            } catch (err) {
                console.log(err)
            }
        },

        setBrand () {
            this.brand = this.brands.find(i => i.id === this.$route.params.id)
        },

        openWine (w) {
            this.wine = w
        },

        changeWine (step) {
            const currentidx = this.wines.findIndex(i => i.id === this.wine.id)
            const idx = currentidx + step
            const len = this.wines.length
            this.wine = this.wines[idx] || this.wines[ idx === len ? 0 : len - 1 ]
        },

        moveTop (delay) {
            setTimeout(() => {
                const navbar = document.querySelector('#navbar').getBoundingClientRect()
                const pos = window.innerHeight - navbar.height + 5

                window.scroll({
                    top: pos,
                    left: 0,
                    behavior: 'smooth'
                })
            }, delay)
        }
    }
}
</script>

<style lang="stylus" scoped>

.section-1
    background-image url("../assets/images/4_vinhos/banner_Vinhos_1920x1080.jpg")

    @media screen and (max-width 768px)
        background-image url("../assets/images/4_vinhos/Vinhos_banners-mobile.jpg")

.has-padding-bottom
    padding-bottom 7.5rem

.has-border-bottom
    border-bottom: solid 1px
    padding-bottom 0.2rem

.has-margin
    margin-top 3rem
    margin-bottom 6.875rem

.main
    padding-top 5rem

    .container > *
        margin-bottom 1.5rem

.router-link-exact-active
    img
        box-shadow: 0px 2px 25px rgba(216, 222, 229, 0.8)
        border-radius 50%

h2 + div
    margin-top 1rem

p + button
    margin-top 1rem

.grid-close-button
    padding-top 30px

</style>
